import React from "react"

const EstateFlatInfo = ({children}) => {
  return (
    <>
      <p>
        Inne świadczenia, o których mowa w art. 19a ust. 1 pkt 3) ustawy z dnia 21 maja 2025 roku o&nbsp;zmianie ustawy o ochronie praw nabywcy lokalu mieszkalnego lub domu jednorodzinnego oraz Deweloperskim Funduszu Gwarancyjnym, które poniesie Kupujący:
      </p>
      <ul>
        <li>akty notarialne, opłaty sądowe, opłaty związane z kredytowaniem nieruchomości,</li>
        <li>zarządzanie i administrowanie częściami wspólnymi w okresie przedwspólnotowym,</li>
        <li>koszty eksploatacji i utrzymania lokalu oraz praw związanych w okresie przedwspólnotowym,</li>
        <li>koszty utrzymania terenów zewnętrznych m.in. terenów rekreacyjnych, roślinności itp.</li>
      </ul>

      <p>
        Wymienione wyżej ceny dotyczące lokali mieszkalnych, pomieszczeń przynależnych, o których mowa w art. 2 ust. 4 ustawy z dnia 24 czerwca 1994 r. o własności lokali, lub praw niezbędnych do korzystania z domu jednorodzinnego są cenami brutto.
      </p>
      {children}
    </>
  )
}

export default EstateFlatInfo

